const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

type Config = {
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
  onWaiting?: (registration: ServiceWorkerRegistration) => void; // New callback for waiting state
};

export function register(config?: Config) {
  if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener("load", () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          console.log(
            "This web app is being served cache-first by a service worker. To learn more, visit https://cra.link/PWA"
          );
        });
      } else {
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl: string, config?: Config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log("Service Worker registered:", registration);

      // Listen for the waiting state
      registration.addEventListener("updatefound", () => {
        const installingWorker = registration.installing;
        if (installingWorker) {
          installingWorker.addEventListener("statechange", () => {
            if (installingWorker.state === "installed") {
              if (navigator.serviceWorker.controller) {
                // New service worker is waiting
                console.log("New service worker is waiting.");
                if (config && config.onWaiting) {
                  config.onWaiting(registration);
                }
              } else {
                // First installation, content is cached
                console.log("Content is cached for offline use.");
                if (config && config.onSuccess) {
                  config.onSuccess(registration);
                }
              }
            }
          });
        }
      });

      // Listen for messages from the service worker
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data && event.data.type === "SW_WAITING") {
          console.log(
            "New service worker is waiting. Triggering update dialog..."
          );
          if (config && config.onWaiting) {
            config.onWaiting(registration);
          }
        }
      });

      // Check if there's already a waiting service worker
      if (registration.waiting) {
        console.log("A service worker is already waiting.");
        if (config && config.onWaiting) {
          config.onWaiting(registration);
        }
      }
    })
    .catch((error) => {
      console.error("Error during service worker registration:", error);
    });
}

function checkValidServiceWorker(swUrl: string, config?: Config) {
  fetch(swUrl, {
    headers: { "Service-Worker": "script" },
  })
    .then((response) => {
      const contentType = response.headers.get("content-type");
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf("javascript") === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => registration.unregister());
    });
  }
}

// Helper function to prompt the user to update
export function promptUserToUpdate(registration: ServiceWorkerRegistration) {
  if (registration.waiting) {
    // Notify the waiting service worker to skip waiting and activate
    registration.waiting.postMessage({ type: "SKIP_WAITING" });

    // Reload the page once the new service worker is activated
    registration.waiting.addEventListener("statechange", (event) => {
      if (registration.waiting?.state === "activated") {
        console.log("New service worker activated. Reloading page...");
        window.location.reload();
      }
    });
  }
}
